var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('h-e-rectangle',{attrs:{"color-full":true,"bg-color":_vm.formatBgColor,"icon":"mdi mdi-clock-outline","title":_vm.formatTitle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }